import { ComponentContent, StockItem } from "../../types/stocks";

export interface IBudgetFriendlyETF {
  exchId_symbol: string;
  exchange: number;
  token: number;
  nseToken: number;
  bseToken: number;
  symbol: string;
  fullName: string;
  ltp: number;
  prevClose: number;
  logo: string;
  sector: string;
  industry: string;
  mktCapType: string;
  mktCap: number;
  isin: string;
  timeStamp: string;
  formattedSymbol: string;
  listingStatus: string;
  tradeable: boolean;
  updateTimestamp: string;
  changePrice: number | string;
  perChange: number | string;
  stockStatus: "positive" | "negative" | "neutral";
  series: string;
  instType: string;
  yearlyhigh: number;
  yearlylow: number;
  idxSymbol: string;
  altName: string;
  redirectURL?: string;
}

export interface IBudgetFriendlyETFsResponse {
  etfList?: IBudgetFriendlyETF[];
  showMore?: boolean;
  showLess?: boolean;
}

export interface BudgetETFFilter {
  label: string;
  value: string;
}

export const BUDGET_ETF_FILTERS: BudgetETFFilter[] = [
  { label: "< ₹100", value: "<100" },
  { label: "< ₹200", value: "<200" },
  { label: "< ₹500", value: "<500" },
];

export const LTP_FILTER_QUERY_PARAM = "ltpFilter";

export const BUDGET_ETF_FALLBACK_STOCK_NOT_FOUND_IMG_URL =
  "https://cms-assets.bajajfinserv.in/is/image/bajajfinancestage/stock-not-found";

export const BUDGET_ETF_DEFAULT_LOGGED_IN_REDIRECTION_URL =
  "https://bfsltrade.bajajfinservsecurities.in/tradingmall";

export const BUDGET_ETF_DEFAULT_SCREEN = "scripdetails";

export const BUDGET_ETF_FALLBACK_ERROR_IMAGE_SRC =
  "/content/dam/bajajfinserv/web/in/en/global/image/xaop/trading-mall/news/errorImage.png";

export const BUDGET_ETF_COLORS = {
  positiveTrend: "text-green-600",
  negativeTrend: "text-red-600",
  border: "border-gray-200",
  primaryText: "text-gray-900",
  secondaryText: "text-gray-600",
  activeTabBg: "bg-bfl-blue",
  activeTabBorder: "border-bfl-blue",
  inactiveTabText: "text-bfl-blue",
  linkPrimary: "text-link-primary",
  borderLinkPrimary: "border-link-primary",
  hoverLinkPrimary: "lg:hover:bg-link-primary",
  white: "text-white",
  whiteBg: "bg-white",
} as const;

export const BUDGET_ETF_ICONS = {
  trendUp: "bf-icon-upstock-growth-vector",
  trendDown: "bf-icon-downstock-growth-vector",
} as const;

export const BUDGET_ETF_MAIN_AEM_DEFAULTS = {
  mainHeading: "All Budget Friendly ETFs listed below",
  heading: "Budget Friendly ETFs",
  description:
    "Equity ETFs are exchange-traded funds that invest primarily in equity stocks. They are suitable for aggressive investors.",
  showMoreText: "Show more",
  showLessText: "Show less",
  errorTitle: "Unable to fetch the ETFs at this time",
  errorDescription: "Please try again later",
  errorRetryButtonText: "Retry",
  errorImageAlt: "Error",
  errorImageSrc: BUDGET_ETF_FALLBACK_ERROR_IMAGE_SRC,
  companyName: "Company name",
  stockNotFoundText: "No ETFs found.",
  stockNotFoundImgUrl: BUDGET_ETF_FALLBACK_STOCK_NOT_FOUND_IMG_URL,
  loggedInRedirectionUrl: BUDGET_ETF_DEFAULT_LOGGED_IN_REDIRECTION_URL,
  screen: BUDGET_ETF_DEFAULT_SCREEN,
} as const;

export type BudgetETFStocksByFilter = Record<string, StockItem[]>;

export interface BudgetETFsContent extends ComponentContent {
  loggedInRedirectionUrl?: string;
  screen?: string;
  webViewTitle?: string;
}

export interface BudgetETFsProps {
  content?: BudgetETFsContent;
}

export interface BudgetETFsClientProps {
  stocksByFilter?: BudgetETFStocksByFilter;
  title: string;
  viewAllLabel: string;
  viewAllHref?: string;
  componentPosition?: string;
  openInNewTab?: boolean | string;
  defaultImage?: string;
  stockNotFoundText?: string;
  stockNotFoundImgUrl?: string;
  modalTitle?: string;
  modalBtnCta?: string;
  successMsg?: string;
  errorMsg?: string;
  loggedInRedirectionUrl?: string;
  screen?: string;
  webViewTitle?: string;
}

export interface BudgetEtfMainProps {
  mainHeading?: string;
  heading?: string;
  description?: string;
  defaultSort?: string;
  componentPosition?: string;
  loggedInRedirectionUrl?: string;
  screen?: string;
  webViewTitle?: string;
  stockNotFoundText?: string;
  stockNotFoundImgUrl?: string;
  initialLtpFilter?: string;
  errorTitle?: string;
  errorDescription?: string;
  errorRetryButtonText?: string;
  errorImageAlt?: string;
  errorImageSrc?: string;
  showMoreText?: string;
  showLessText?: string;
  companyName?: string;
}

export interface BudgetETFMainClientProps {
  initialStocks: StockItem[];
  initialShowMore?: boolean;
  initialShowLess?: boolean;
  initialLtpFilter: string;
  defaultSort?: string;
  heading?: string;
  description?: string;
  loggedInRedirectionUrl?: string;
  screen?: string;
  webViewTitle?: string;
  stockNotFoundText?: string;
  stockNotFoundImgUrl?: string;
  componentPosition?: string;
  showMoreText?: string;
  showLessText?: string;
  companyName?: string;
  mainHeading?: string;
}
